var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"services-options-form"},[(_vm.clientOptions.length)?_c('field-box',{attrs:{"name":"client_id","type":"select","options":_vm.clientOptions}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }